import axios from "axios";
import { supabase } from "./supabase-service";
import { store } from "@/store";
import { logout } from "@/store/slices/authSlice";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

// Request interceptor
api.interceptors.request.use(
  async (config) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (session?.access_token) {
      config.headers.Authorization = session.access_token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout());
      window.location.href = "/signin";
    }
    return Promise.reject(error);
  }
);

export default api;
